<template>
  <div class="Loginbg">
    <div class="logo text-center wl-txt">
      <img
        alt
        src="../../static/images/HRM_logo_2021_V_2048x1024.png"
        class="img-responsive"
      />
      <h2 v-if="serverRouter" class="text-center text-white">
        {{
          this.serverRouter.ChiName != ""
            ? this.serverRouter.ChiName
            : this.serverRouter.EngName == ""
            ? this.serverRouter.CompCode
            : this.serverRouter.EngName
        }}
      </h2>
      <h2 v-else class="text-center text-white">
        {{ t.t(dictEnum.LBL_PlsEnterCompCode) }}
      </h2>
    </div>
    <div class="row m-t-40">
      <div class="col-lg-5"></div>
      <div class="col-lg-2">
        <form class="form-horizontal" @submit="login">
          <div v-if="errors.length">
            <div class="alert alert-danger" v-for="i in errors" :key="i">
              {{ i }}
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <img
                src="../../static/images/Front-img/user.png"
                class="f-img"
                alt
              />
              <input
                :class="{
                  'form-control': true,
                  'bg-disabled': !this.serverRouter
                }"
                type="text"
                :disabled="!serverRouter"
                v-model="username"
                :placeholder="t.t(dictEnum.LBL_Username)"
              />
              <!-- maxlength="10" -->
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <img
                src="../../static/images/Front-img/lock.png"
                class="f-img"
                alt
              />
              <input
                :class="{
                  'form-control': true,
                  'bg-disabled': !this.serverRouter
                }"
                type="password"
                :disabled="!serverRouter"
                v-model="password"
                :placeholder="t.t(dictEnum.LBL_Password)"
                v-on:keyup.enter="login"
              />
              <!-- maxlength="64" -->
            </div>
          </div>
          <div class="d-flex">
            <div class="col-6">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck1"
                  :disabled="!serverRouter"
                  v-model="isRememberMe"
                />
                <label
                  :class="{
                    'custom-control-label': true,
                    'text-white': true,
                    'text-disabled': !this.serverRouter
                  }"
                  for="customCheck1"
                >
                  {{ t.t(dictEnum.LBL_RememberMe) }}
                </label>
              </div>
            </div>
            <div class="col-6">
              <button
                :class="{
                  'text-white': true,
                  'bg-transparent': true,
                  'border-0': true,
                  'text-disabled': !this.serverRouter
                }"
                type="button"
                data-toggle="modal"
                :disabled="!serverRouter"
                v-b-modal.modal-forgetPass
                @click="onforgetPass"
              >
                {{ t.t(dictEnum.LBL_ForgetPassword) }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12"></div>
          </div>
          <div class="form-group text-center m-t-40">
            <div class="col-xs-12">
              <button
                :disabled="!serverRouter"
                @click="login"
                class="
                  btn btn-primary btn-block btn-lg
                  waves-effect waves-light
                "
                type="button"
              >
                {{ t.t(dictEnum.BTN_Login) }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-5"></div>
    </div>

    <b-modal
      id="modal-forgetPass"
      :title="t.t(dictEnum.LBL_ForgetPassword)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="forgetPass"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Email) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input v-model="email"></b-form-input>
              <!-- maxlength="100" -->
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
import LoginService from "@/service/LoginService";
import MenuRightService from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import DataSyncService from "@/service/DataSyncService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import ServerService from "@/service/ServerService";
import StoreGetter from "@/constants/StoreGetter";

export default {
  name: "Login",
  data() {
    return {
      errors: [],
      username: "",
      password: "",
      email: "",
      isRememberMe: false,
      dictEnum: dictEnum
    };
  },
  computed: {
    t() {
      return t;
    },
    serverRouter() {
      return this.$store.getters[StoreGetter.serverRouter];
    }
  },
  methods: {
    dispatchRememberMe() {
      this.$store.dispatch({
        type: `AuthenticationStore/RememberMe`,
        payload: {
          isRememberMe: this.isRememberMe,
          username: this.username,
          password: this.password
        }
      });
    },
    hasRight(key, menuId) {
      if (Object.keys(this.$props.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightService.hasRightInMenu(
          this.$props.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    onforgetPass() {
      this.email = "";
    },
    async login() {
      this.errors = [];
      const loginDetails = {
        deviceid: 1,
        username: this.username,
        password: this.password,
        compCode: this.$store.getters[StoreGetter.serverRouter].CompCode
      };

      this.dispatchRememberMe();

      const response = await LoginService.login(loginDetails);
      if (response.data.IsSuccess) {
        await this.$store.dispatch({
          type: "AuthenticationStore/Login",
          payload: response.data.Data
        });
        const lang = response.data.Data.Lang;
        await this.setMenuRights();
        await this.setSysParams();
        await this.setMsg(lang);

        this.$router.push({ path: "approval" });
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async setMsg(lang) {
      const res = await t.getMsg(lang);
      if (res.data.IsSuccess) {
        await this.$store.dispatch({
          type: `SysMsgStore/refreshStore`,
          payload: res.data.Data
        });
      } else {
        SweetAlertService.warning("Warn", res.data.Message);
      }
    },

    async setMenuRights() {
      const obj = { userId: this.username };
      const responseUserRights = await MenuRightService.getMenuRights(obj);
      if (responseUserRights.data.IsSuccess) {
        responseUserRights.data.Data.splice(20, 0, {
          UserGrp: "",
          MenuID: "050900",
          AlwWrite: true,
          AlwDel: true,
          AlwChg: true,
          AlwImp: true,
          AlwExp: true,
          AlwPrt: true,
          AlwRead: true,
          EDesc: null,
          CDesc: null,
          MenuName: "值 勤 計 劃",
          AddBy: ""
        });
        await this.$store.dispatch({
          type: "SysMenuStore/refreshSysMenu",
          payload: responseUserRights.data.Data
        });
        console.log("====responseUserRights====", responseUserRights);
      } else {
        SweetAlertService.warning("Warn", responseUserRights.data.Message);
      }
    },
    async setSysParams() {
      const obj = {};
      const response = await DataSyncService.getSysParams(obj);
      if (response.data.IsSuccess) {
        this.$store.dispatch({
          type: "SysParamsStore/refreshSysParams",
          payload: response.data.Data
        });
      }
    },

    async forgetPass() {
      if (!this.email) {
        SweetAlertService.warning(
          "Warn",
          "Warn",
          t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.validEmail(this.email)) {
        SweetAlertService.warning(
          "Warn",
          "Warn",
          t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_Invaild)
        );
        return;
      }
      const obj = {
        Email: this.email,
        compCode: this.$store.getters[StoreGetter.serverRouter].CompCode
      };
      const response = await LoginService.forgotpassword(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    assignRemembered() {
      if (this.$store.getters[StoreGetter.isRememberMe]) {
        this.isRememberMe = this.$store.getters[StoreGetter.isRememberMe];
        this.username = this.$store.getters[StoreGetter.rememberedUsername];
        this.password = this.$store.getters[StoreGetter.rememberedPassword];
      }
    },
    async findBaseUrl() {
      let compCode = this.$router.currentRoute.path.replace("/login/", "");
      if (compCode) {
        try {
          const res = await ServerService.getServerRouterByCompCode(compCode);
          if (res.data.IsSuccess) {
            this.$store.dispatch({
              type: `ServerRouterStore/refershServerRouter`,
              payload: res.data.Data
              // payload: {
              //   ServerIP: "https://localhost:5001/api/",
              //   CompCode: res.data.Data.CompCode
              // }
            });
          } else {
            this.$store.dispatch({
              type: `ServerRouterStore/refershServerRouter`,
              payload: undefined
            });
          }
        } catch (e) {}
      }
    }
  },

  async mounted() {
    await this.findBaseUrl();
    this.assignRemembered();
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue